import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { FreeFormImage } from "@/Patient/Api/Dto/Responses/FreeFormImage";
import { HandNoteHandler } from "./Handlers/Local/HandNoteHandler";

let defaultInstance: NoteStore;

class NoteStore extends BaseStore {
    private mapper: RequestMapper;
    private responseMapper: ServerResponseMapper;
    private handler: HandNoteHandler;

    public editNote: FreeFormImage;

    constructor() {
        super();
        var self = this;
        this.handler = new HandNoteHandler();
        this.mapper = new RequestMapper();
        this.mapper.AddInstance(this.handler);
        this.responseMapper = new ServerResponseMapper();
        this.ClientDispatchTokenNote = HandNoteModule.localNoteDispatcher.register((request: LocalEvent) => {
            self.mapper.Map(request, self);
        });
        this.ServerDispatchToken = HandNoteModule.serverNoteDispatcher.register((response: ServerEvent) => { self.responseMapper.Map(response, self); });
    }

    public static createSingleton(): NoteStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new NoteStore());
    }

    public static createSingletonFrom(store: NoteStore, copy: boolean = true): NoteStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }
}

export { NoteStore, defaultInstance as noteStore };
